import { motion } from 'framer-motion'
import React from 'react'
import CSS from './CenterIcon.module.css'

interface Props {
    icon: string
}
function CenterIcon(props: Props) {
    return (
        <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{
                type: 'spring',
                duration: 20,
            }}
            exit={{ opacity: 0 }}
        >
            <img className={CSS.icon} src={props.icon} width={50} />
        </motion.div>
    )
}

export default CenterIcon
